<div class="container-corps">
  <div
    [matTooltip]="alarmLog().acquit ? '' : ('ALARM.UNREADALARM' | translate)"
    (click)="acquitLog()"
    class="container-icon">
    <i [class]="alarmLog().acquit ? 'material-icons' : 'material-icons shake'">
      {{ alarmLog().acquit ? 'notifications' : 'notifications_active' }}
    </i>
  </div>

  <div class="container-infos">
    @if (isDisplayAlarmName()) {
      @if ($alarmsById()[alarmLog().uid_alarm] && $device(); as device) {
        <div
          class="container-infos-name"
          matTooltip="{{ $alarmsById()[alarmLog().uid_alarm].name }} - {{ device.registration }}">
          <p class="alarm-name">
            {{ $alarmsById()[alarmLog().uid_alarm].name }}
          </p>
          <p>-</p>
          <p class="device-name">
            {{ device.registration }}
          </p>
        </div>
      }
    } @else {
      <div>
        @if ($device(); as device) {
          <p>
            {{ device.registration }}
          </p>
        }
      </div>
    }

    <div>
      <p class="info-timestamp">
        {{ alarmLog().timestamp * 1000 | dynamicDate: 'short' }}
      </p>
    </div>
  </div>

  <div class="container-send">
    @if (alarmLog().send_mail) {
      <i class="material-icons" matTooltip="{{ alarmLog().send_mail }}">mail</i>
    }
    @if (alarmLog().send_sms) {
      <i class="material-icons" matTooltip="{{ alarmLog().send_sms }}">smartphone</i>
    }
  </div>
</div>
